// @flow
import { dateFormat } from 'app/common/api/requests/food/schools/cafeteria_orders';
import { calcPeriodFromStart } from 'app/common/ui-next/plain-date-period';


const dummyItems = [{ id: 'dummy', title: 'dummy' }];

const periodItems = () => {
  const period = calcPeriodFromStart(null, null, 'month', dateFormat);
  return ([dummyItems, period]);
};

export default periodItems;
